module.exports = __webpack_public_path__ + "static/opensans-extrabold-webfont-a6fbe2d7e422a354bf140944753a4f3a.woff";